import { render } from "./Main.vue?vue&type=template&id=7b8c9c59"
import script from "./Main.vue?vue&type=script&lang=ts"
export * from "./Main.vue?vue&type=script&lang=ts"
script.render = render

export default script